import { useState } from "react";
import Swal from "sweetalert2";
import api from "../../services/api.js";

export default function AddBillableItemModal({
  open,
  onClose,
  userid,
  token,
  onSuccess, // 🔥 trigger refetch
}) {
  const [form, setForm] = useState({
    direction: "IN",
    amount: "",
    description: "",
    source_type: "ADJUSTMENT",
  });

  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.amount || !form.description) {
      return Swal.fire(
        "Validasi gagal",
        "Amount dan description wajib diisi",
        "warning"
      );
    }

    setLoading(true);
    try {
      await api.post(
        "/billable-item",
        {
          userid: userid,
          direction: form.direction,
          amount: Number(form.amount),
          description: form.description,
          source_type: form.source_type,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      Swal.fire("Berhasil", "Billable item berhasil ditambahkan", "success");

      // 🔥 refresh data parent
      onSuccess?.();

      // reset & close
      setForm({
        direction: "IN",
        amount: "",
        description: "",
        source_type: "ADJUSTMENT",
      });

      onClose();
    } catch (err) {
      console.error("addBillableItem error:", err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Gagal menambahkan billable item",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-900 w-full max-w-md rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-6">
        <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-100">
          Tambah Billable Item
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Direction */}
          <div>
            <label className="block text-sm mb-1 text-gray-700 dark:text-gray-300">
              Tipe
            </label>
            <select
              name="direction"
              value={form.direction}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border
                bg-white dark:bg-gray-800
                border-gray-300 dark:border-gray-600
                text-gray-800 dark:text-gray-200"
            >
              <option value="IN">Tambah Tagihan (IN)</option>
              <option value="OUT">Potongan / Restitusi (OUT)</option>
            </select>
          </div>

          {/* Amount */}
          <div>
            <label className="block text-sm mb-1 text-gray-700 dark:text-gray-300">
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={form.amount}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border
                bg-white dark:bg-gray-800
                border-gray-300 dark:border-gray-600
                text-gray-800 dark:text-gray-200"
              placeholder="Contoh: 50000"
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm mb-1 text-gray-700 dark:text-gray-300">
              Deskripsi
            </label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              rows={3}
              className="w-full px-3 py-2 rounded border
                bg-white dark:bg-gray-800
                border-gray-300 dark:border-gray-600
                text-gray-800 dark:text-gray-200"
              placeholder="Keterangan penyesuaian"
            />
          </div>

          {/* Source Type */}
          <div>
            <label className="block text-sm mb-1 text-gray-700 dark:text-gray-300">
              Source
            </label>
            <select
              name="source_type"
              value={form.source_type}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border
                bg-white dark:bg-gray-800
                border-gray-300 dark:border-gray-600
                text-gray-800 dark:text-gray-200"
            >
              <option value="ADJUSTMENT">Adjustment</option>
              <option value="RESTITUTION">Restitusi</option>
              <option value="SERVICE_FEE">Service Fee</option>
              <option value="PENALTY">Penalty</option>
              <option value="DISCOUNT">Discount</option>
              <option value="ADMIN">Admin</option>
            </select>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded
                bg-gray-200 dark:bg-gray-700
                text-gray-800 dark:text-gray-200"
            >
              Batal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 rounded
                bg-blue-600 hover:bg-blue-700
                text-white
                disabled:opacity-50"
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
